import { StopActivityProps } from '../../models/stopActivity.model';
import { EGPSTrackingStatus } from "../../utils/constants";
export interface IUserInformation {
  driverId?: string;
  filter?: IFilter;
}
export interface IFilter {
  carrierTendered?: boolean;
  carrierAssigned?: boolean;
  driverAssigned?: boolean;
  inTransit?: boolean;
  deliveredNeedsPaperWork?: boolean;
  deliveredWithPaperWork?: boolean;
}
export interface IPagination {
  pageSize?:number;
  pageIndex?:number;
  myLoadPageFilter?:IPageFilter[] | null;
}

export interface IPageFilter {
  filterName?:string | null;
  filterValue?:string | null;
}
export interface ILoadInfromation {
  carrierAssignedCount: number;
  inTransitCount: number;
  driverAssignedCount: number;
  driverAssignedPendingCount: number;
  deliveredCount: number;
  deliveredNeedsPaperWorkCount: number;
  deliveredWithPaperWorkCount: number;
  carrierAssginedShipments: [IShipmentData];
  inTransitShipments: [IShipmentData];
  driverAssignedShipments: [IShipmentData];
  driverAssignmentPendingShipments: [IShipmentData];
  deliveredNeedsPaperWorkShipments: [IShipmentData];
}
export interface IShipmentData {
  [index: number]: any;
  carrierAssignedLoads?: IShipment[];
}

export interface IShipment {
  shipmentId: string;
  invoiceCreatedDateTime: string;
  documentStatus: string;
  transportMode: string;
  totalWeight: number;
  weightUOM: string;
  totalDistance: number;
  distanceUOM: string;
  numberOfStops: number;
  sourceTMS: string;
  driverAssignmentStatus: string;
  assignedCarrierId: string;
  isHazardous: boolean;
  isHighValue: boolean;
  isTemperatureControlled: boolean;
  readyDateTime: string;
  readyDateTimeZone: string;
  equipmentType: string;
  predecessorShipmentId: string;
  successorShipmentId: string;
  assignmentStatus: string;
  executionStatus: string;
  shipmentServices: string;
  loadStop: [IShipmentStop];
  shipmentReferences: [IShipmentReference];
  shipmentAndStopReferences: [IShipmentReference];
  shipmentNotes: [IShipmentNote];
  shipmentInvolvedParties: [IShipmentInvolvedParty];
  shipmentTenderedCarriers : [IShipmentTenderedCarriers];
  startCity: string;
  startState: string;
  startDateTime: string;
}
export interface IShipmentStop {
  stopId: string;
  locationId: string;
  stopType: string;
  sequenceNo: number;
  locationName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  timeZone: string;
  longitude: string;
  latitude: string;
  estimatedArrivalDateTime: string;
  plannedArrivalDateTime: string;
  actualArrivalDateTime: string;
  estimatedStopDuration: string;
  plannedDepartureDateTime: string;
  actualDepartureDateTime: string;
  appointmentEarlyDateTime: string;
  appointmentState?: string;
  appointmentLateDateTime: string;
  estimatedStopDurationUom: string;
  actualETADateTime: string;
  shipmentId: string;
  stopReference: [IShipmentReference];
  locationNotes: [IShipmentNote];
  stopActivity: [StopActivityProps];
  trailerValidation: ITrailerValidation;
}
export interface IShipmentReference {
  id: number;
  type: string;
  value: string;
  stopId: string;
  shipmentId: string;
}
export interface IShipmentTenderedCarriers {
  recordId : string;
  shipmentId : string;
  carrierId : string;
  offeredRate : number;
}
export interface IShipmentNote {
  id: number;
  type: string;
  value: string;
  shipmentId: string;
  stopId: string;
}

export enum EquipmentFlow {
  TRAILER_IN = 'TRAILER_IN',
  TRAILER_OUT = 'TRAILER_OUT',
  INOUT = 'INOUT',
  NA = 'NA'
}
export interface ITrailerValidation {
  validationCode: string;
  validationMessage: string;
  validationStatus: ValidationStatus;
}
enum ValidationStatus {
  SUCCESS,
  WARNING,
  FAILURE
}
export interface IShipmentInvolvedParty {
  id: number;
  partyId: string;
  partyType: string;
  partyName: string;
  partyEmail: string;
  partyPhone: string;
}

export type StartLocation = {
  sourceSystem: string;
  carrierPro: string;
  carrierScac: string;
  shipmentId: string;
  carrierId: string;
  userId: string;
  latitude: string;
  longitude: string;
  city: string;
  state: string;
  country: string;
  startDateTime: string;
  timeZone: string;
  positionDateTime: string;
  gpsTrackingStatus: number;
};

export type StopInformation = {
  sourceSystem: string;
  carrierId: string;
  userId: string;
  shipmentId: string;
  carrierScac: string;
  carrierPro: string;
  city: string;
  state: string;
  country: string;
  latitude: number;
  longitude: number;
  timeZone: string;
  positionDateTime: string;
  stopId: string;
  sequenceNo: number;
  stopNumber: number;
  locationId: string;
  actualArrivalDateTime: string;
  actualETADateTime: string;
  actualDepartureDateTime: string;
  stopTrailerActivity: StopActivityProps[];
  gpsTrackingStatus: number;
  geoTrackingStatus?: boolean;
  schneiderEquipment?: boolean;
  userConcentForTrailerWarning?: boolean;
  lateArrivalReason?:string |null;
};

export interface IStartTripInfo {
  userId: string;
  shipmentId: string;
  roles: any;
  gpsTrackingStatus: number;
  carrierId: string;
}

export type CompleteTrip = {
  sourceSystem: string;
  shipmentId: string;
  carrierId: string;
  userId: string;
};
export type UpdateGPS = {
  shipmentId: string;
  gpsTrackingStatus: EGPSTrackingStatus
};
